export const
    url = 'https://citas.cajamag.com.co/api';
    /*url = 'https://citas.cajamag.com.co/api/'*/
    



// WEBPACK FOOTER //
// ./src/helpers/urls.js